import axiosInstance from '../variables/api/axiosInstance';

const CLE_CACHE = 'navigation';
const CLE_CACHE_CHEMINS = 'navigation-chemins-declares';

/** Menu en cache, ou null si jamais charge. */
export const lireNavigationEnCache = () => {
  try {
    const brut = sessionStorage.getItem(CLE_CACHE);
    return brut ? JSON.parse(brut) : null;
  } catch {
    return null;
  }
};

/**
 * Catalogue des chemins declares au menu (tous droits confondus), ou null s'il
 * n'a pas encore ete charge. Sert uniquement a la garde de routes : il dit
 * quels sous-chemins sont des ecrans a part entiere.
 */
export const lireCheminsDeclaresEnCache = () => {
  try {
    const brut = sessionStorage.getItem(CLE_CACHE_CHEMINS);
    return brut ? JSON.parse(brut) : null;
  } catch {
    return null;
  }
};

/** Purge le cache - a appeler a la deconnexion, sinon l'utilisateur suivant herite du menu. */
export const viderNavigation = () => {
  sessionStorage.removeItem(CLE_CACHE);
  sessionStorage.removeItem(CLE_CACHE_CHEMINS);
};

/**
 * Recharge le menu depuis l'API et le met en cache. Propage l'erreur reseau.
 *
 * Le catalogue des chemins declares est recupere dans la foulee, mais son echec
 * n'interrompt PAS le chargement du menu : sans lui la garde retombe sur son
 * ancienne regle (prefixe simple), ce qui est trop permissif mais ne bloque
 * personne. L'inverse - un menu vide parce que le catalogue a echoue - laisserait
 * l'agent devant une barre laterale vide.
 */
export const chargerNavigation = async () => {
  const reponse = await axiosInstance.get('/v1/navigation');
  const menu = reponse.data?.data ?? [];
  sessionStorage.setItem(CLE_CACHE, JSON.stringify(menu));

  try {
    const r = await axiosInstance.get('/v1/navigation/chemins-declares', { skipErrorToast: true });
    sessionStorage.setItem(CLE_CACHE_CHEMINS, JSON.stringify(r.data?.data ?? []));
  } catch {
    /* garde degradee, jamais bloquante - voir le commentaire ci-dessus */
  }

  return menu;
};
